import "@hotwired/turbo-rails"
import "@fortawesome/fontawesome-free/js/all"
import "flowbite/dist/flowbite.turbo.js"
import "@whereby.com/browser-sdk/embed"

import PusherManager from "./services/pusher_manager"
import TawktoWidget from "./services/tawkto"
import "./controllers"
import "./util"

import { setupTurboRedirect, setupTimezoneCookie } from "./util/common"
import { initFieldErrorClearing } from "./util/field_error_clearing"

setupTurboRedirect()
setupTimezoneCookie()
initFieldErrorClearing()
TawktoWidget.initialize()

document.addEventListener("DOMContentLoaded", () => {
  PusherManager.initialize()
})

import "./channels/user_channel"
